<a class="details-file" target="_blank" (click)="handleClick.emit({link, title})">
  <div class="inner">
    <div class="ico">
      <mat-icon fontIcon="insert_drive_file"></mat-icon>
    </div>
    <div class="des">
      <mat-icon fontIcon="insert_drive_file"></mat-icon>
      <span class="my-des alt">{{ title }}</span>
    </div>
  </div>
  <div class="overlay">
    <div><mat-icon fontIcon="insert_drive_file"></mat-icon></div>
    <div>
      <span class="my-des alt">{{ title }}</span>
      <span class="text-muted">
        {{ size }}
      </span>
    </div>
  </div>
</a>